// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./common/fonts/elevance-sans/TTF/ElevanceSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./common/fonts/elevance-sans/TTF/ElevanceSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Semibold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./common/fonts/elevance-sans/TTF/ElevanceSans-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./common/fonts/elevance-sans/WEB/ElevanceSans-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./common/fonts/elevance-sans/TTF/ElevanceSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700&family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bitter:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Elevance Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('svg'),
  url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
font-weight: 400;
font-style: normal;
font-display: swap;
}

@font-face {
font-family: "Elevance Sans";
src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('svg'),
  url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
font-weight: 500;
font-style: normal;
font-display: swap;
}

@font-face {
font-family: "Elevance Sans";
src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('svg'),
  url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
font-weight: 600;
font-style: normal;
font-display: swap;
}

@font-face {
font-family: "Elevance Sans";
src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('svg'),
  url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype');
font-weight: 700;
font-style: normal;
font-display: swap;
}


/* Override Ant Design Global Style */
html,
body {
  height: 100%;
  margin: 0;
}

body {
  background: #f7f7f7;
  font-family: "Elevance Sans", "Lato", -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-variant-ligatures:none;
}

.ant-form-item-label > label {
  font-weight: 600;
}

.ant-radio > .ant-radio-inner {
  border-color: #7d7878;
}

.ant-checkbox > .ant-checkbox-inner {
  border-color: #7d7878;
}

.ant-notification {
  z-index: 900 !important;
  right: 0 !important;
  left: 0 !important;
  margin: auto !important;
  max-width: fit-content !important;
  width: auto !important;
}

.alert {
  text-align: left;
  letter-spacing: 0px;
  color: #d20a3c;
  opacity: 1;
  padding: 7px;
}

.success {
  text-align: left;
  letter-spacing: 0px;
  color: #53b1a3;
  opacity: 1;
  padding: 7px;
}

.ant-table thead > tr > th {
  background: #ffffff !important;
}

.heading-underline {
  border-bottom: white solid 1px;
  display: table;
  margin: 0 auto;
  padding-bottom: 10px;
}

.ant-input,
.ant-input-password {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #cccccc;
  border-radius: none;
  color: black;
  font-weight: 500;
  font-size: 18px;
  line-height: 2.5;
  opacity: 0.7;
}
.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  color: black;
  font-weight: 500;
  font-size: 18px;
  line-height: 3;
  opacity: 0.7;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  border: 1px solid #cccccc;
}

.ant-form-item-label > label {
  font-weight: 600;
  color: #666666;
  font-size: 18px;
}

.ant-form-item-label {
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  font-size: 18px;
  line-height: 26px !important;
  font-family: Lato;
  font-weight: normal;
}

.btn-large-primary {
  font-size: 14px;
  font-family: "Elevance Sans";
  font-weight: 400;
  color: #fff;
  background-color: #286ce2 !important;
  border-radius: 0%;
}

.btn-large-primary:hover {
  background-color: #2453a6 !important;
}

.btn-large-secondary {
  font-size: 14px;
  font-family: "Elevance Sans";
  font-weight: 400;
  color: #286ce2;
  background-color: #fff;
  border-radius: 0%;
  border: 1px solid #286ce2;
}
.btn-large-secondary:hover {
  color: #2453a6 !important;
  border: 1px solid #2453a6;
}

.ant-card-head-title {
  white-space: normal !important;
}

/* .ant-form-item-label > label.ant-form-item-required::after {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: Lato;
  line-height: 1;
  content: '*';
} */

html {
  overflow-y: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}

.ant-notification-hook-holder,
.ant-notification-notice {
  margin: auto;
}

.ant-drawer-content {
  height: 100%;
  overflow-y: scroll;
}

.ant-card-meta-description {
  font-family: "Elevance Sans";
  color: #333333;
  font-weight: 400;
}

.ant-card-meta-description {
  white-space: normal;
}

.ant-select-item-option-content {
  white-space: normal !important;
}

.ant-select-selector {
  height: 55px !important;
}

.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 50px;
}

button,
ant-btn {
  font-weight: 500 !important;
  font-family: Elevance Sans !important;
  font-size: 16px !important;
  border-radius: 100px !important;
}

.notification-tooltip,
  .ant-tooltip-inner {
    color: black;
    min-width: 30px;
    padding: 15px 15px;
    font-family: "Elevance Sans";
  }

.notification-tooltip,
  .ant-tooltip-arrow-content {
    width: auto;
    height: 10px;
  }


  a, .image-focus,
  #internal-app-backToTop,
  .btn-link,.ant-btn,.ant-collapse-header,
  .card__api_list,
  .ant-tabs-tab-btn,.react-player__preview,
  .ant-pagination-item-link,
  .ant-switch ,
  .filter-checkbox,
  .expand-button {
    &:focus-visible {
      outline: 2px solid #0079c2;
      outline-offset: 2px;
      border-radius: 2px;
    }
  }

  /* Focus styles for radio button inputs */
  .ant-radio-input:focus-visible {
    outline: 2px solid #0079c2 !important;
    outline-offset: 2px !important;
    border-radius: 50% !important;
    opacity: 1;
  }

  /* Focus styles for checkbox inputs */
  .ant-checkbox-input:focus-visible {
    outline: 2px solid #0079c2 !important;
    outline-offset: 2px !important;
    border-radius: 2px !important;
    opacity: 1;
  }`, "",{"version":3,"sources":["webpack://./client/index.css"],"names":[],"mappings":"AAIA;EACE,4BAA4B;EAC5B;;;4DAGmF;AACrF,gBAAgB;AAChB,kBAAkB;AAClB,kBAAkB;AAClB;;AAEA;AACA,4BAA4B;AAC5B;;;4DAGoF;AACpF,gBAAgB;AAChB,kBAAkB;AAClB,kBAAkB;AAClB;;AAEA;AACA,4BAA4B;AAC5B;;;6DAGsF;AACtF,gBAAgB;AAChB,kBAAkB;AAClB,kBAAkB;AAClB;;AAEA;AACA,4BAA4B;AAC5B;;;6DAGkF;AAClF,gBAAgB;AAChB,kBAAkB;AAClB,kBAAkB;AAClB;;;AAGA,qCAAqC;AACrC;;EAEE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,uBAAuB,EAAE,+BAA+B;AAC1D;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,qCAAqC;EACrC,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,4BAA4B;EAC9B;;AAEF;;IAEI,WAAW;IACX,YAAY;EACd;;;EAGA;;;;;;;;;IASE;MACE,0BAA0B;MAC1B,mBAAmB;MACnB,kBAAkB;IACpB;EACF;;EAEA,yCAAyC;EACzC;IACE,qCAAqC;IACrC,8BAA8B;IAC9B,6BAA6B;IAC7B,UAAU;EACZ;;EAEA,qCAAqC;EACrC;IACE,qCAAqC;IACrC,8BAA8B;IAC9B,6BAA6B;IAC7B,UAAU;EACZ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700&family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Bitter:ital,wght@0,100..900;1,100..900&display=swap');\n\n\n@font-face {\n  font-family: \"Elevance Sans\";\n  src: url('./common/fonts/elevance-sans/WEB/ElevanceSans-Regular.woff2') format('woff2'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Regular.woff') format('woff'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Regular.svg') format('svg'),\n  url('./common/fonts/elevance-sans/TTF/ElevanceSans-Regular.ttf') format('truetype');\nfont-weight: 400;\nfont-style: normal;\nfont-display: swap;\n}\n\n@font-face {\nfont-family: \"Elevance Sans\";\nsrc: url('./common/fonts/elevance-sans/WEB/ElevanceSans-Medium.woff2') format('woff2'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Medium.woff') format('woff'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Medium.svg') format('svg'),\n  url('./common/fonts/elevance-sans/TTF/ElevanceSans-Medium.ttf') format('truetype');\nfont-weight: 500;\nfont-style: normal;\nfont-display: swap;\n}\n\n@font-face {\nfont-family: \"Elevance Sans\";\nsrc: url('./common/fonts/elevance-sans/WEB/ElevanceSans-Semibold.woff2') format('woff2'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Semibold.woff') format('woff'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Semibold.svg') format('svg'),\n  url('./common/fonts/elevance-sans/TTF/ElevanceSans-Semibold.ttf') format('truetype');\nfont-weight: 600;\nfont-style: normal;\nfont-display: swap;\n}\n\n@font-face {\nfont-family: \"Elevance Sans\";\nsrc: url('./common/fonts/elevance-sans/WEB/ElevanceSans-Bold.woff2') format('woff2'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Bold.woff') format('woff'),\n  url('./common/fonts/elevance-sans/WEB/ElevanceSans-Bold.svg') format('svg'),\n  url('./common/fonts/elevance-sans/TTF/ElevanceSans-Bold.ttf') format('truetype');\nfont-weight: 700;\nfont-style: normal;\nfont-display: swap;\n}\n\n\n/* Override Ant Design Global Style */\nhtml,\nbody {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  background: #f7f7f7;\n  font-family: \"Elevance Sans\", \"Lato\", -apple-system, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-variant-ligatures:none;\n}\n\n.ant-form-item-label > label {\n  font-weight: 600;\n}\n\n.ant-radio > .ant-radio-inner {\n  border-color: #7d7878;\n}\n\n.ant-checkbox > .ant-checkbox-inner {\n  border-color: #7d7878;\n}\n\n.ant-notification {\n  z-index: 900 !important;\n  right: 0 !important;\n  left: 0 !important;\n  margin: auto !important;\n  max-width: fit-content !important;\n  width: auto !important;\n}\n\n.alert {\n  text-align: left;\n  letter-spacing: 0px;\n  color: #d20a3c;\n  opacity: 1;\n  padding: 7px;\n}\n\n.success {\n  text-align: left;\n  letter-spacing: 0px;\n  color: #53b1a3;\n  opacity: 1;\n  padding: 7px;\n}\n\n.ant-table thead > tr > th {\n  background: #ffffff !important;\n}\n\n.heading-underline {\n  border-bottom: white solid 1px;\n  display: table;\n  margin: 0 auto;\n  padding-bottom: 10px;\n}\n\n.ant-input,\n.ant-input-password {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 1px solid #cccccc;\n  border-radius: none;\n  color: black;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 2.5;\n  opacity: 0.7;\n}\n.ant-select-single .ant-select-selector .ant-select-selection-item,\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  color: black;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 3;\n  opacity: 0.7;\n}\n\n.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  border: 1px solid #cccccc;\n}\n\n.ant-form-item-label > label {\n  font-weight: 600;\n  color: #666666;\n  font-size: 18px;\n}\n\n.ant-form-item-label {\n  letter-spacing: 0px;\n  color: #333333;\n  opacity: 1;\n  font-size: 18px;\n  line-height: 26px !important;\n  font-family: Lato;\n  font-weight: normal;\n}\n\n.btn-large-primary {\n  font-size: 14px;\n  font-family: \"Elevance Sans\";\n  font-weight: 400;\n  color: #fff;\n  background-color: #286ce2 !important;\n  border-radius: 0%;\n}\n\n.btn-large-primary:hover {\n  background-color: #2453a6 !important;\n}\n\n.btn-large-secondary {\n  font-size: 14px;\n  font-family: \"Elevance Sans\";\n  font-weight: 400;\n  color: #286ce2;\n  background-color: #fff;\n  border-radius: 0%;\n  border: 1px solid #286ce2;\n}\n.btn-large-secondary:hover {\n  color: #2453a6 !important;\n  border: 1px solid #2453a6;\n}\n\n.ant-card-head-title {\n  white-space: normal !important;\n}\n\n/* .ant-form-item-label > label.ant-form-item-required::after {\n  display: inline-block;\n  margin-right: 4px;\n  color: #ff4d4f;\n  font-size: 14px;\n  font-family: Lato;\n  line-height: 1;\n  content: '*';\n} */\n\nhtml {\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n::-webkit-scrollbar {\n  width: 0px;\n  background: transparent; /* make scrollbar transparent */\n}\n\n.ant-notification-hook-holder,\n.ant-notification-notice {\n  margin: auto;\n}\n\n.ant-drawer-content {\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.ant-card-meta-description {\n  font-family: \"Elevance Sans\";\n  color: #333333;\n  font-weight: 400;\n}\n\n.ant-card-meta-description {\n  white-space: normal;\n}\n\n.ant-select-item-option-content {\n  white-space: normal !important;\n}\n\n.ant-select-selector {\n  height: 55px !important;\n}\n\n.ant-select-single .ant-select-selector .ant-select-selection-item,\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 50px;\n}\n\nbutton,\nant-btn {\n  font-weight: 500 !important;\n  font-family: Elevance Sans !important;\n  font-size: 16px !important;\n  border-radius: 100px !important;\n}\n\n.notification-tooltip,\n  .ant-tooltip-inner {\n    color: black;\n    min-width: 30px;\n    padding: 15px 15px;\n    font-family: \"Elevance Sans\";\n  }\n\n.notification-tooltip,\n  .ant-tooltip-arrow-content {\n    width: auto;\n    height: 10px;\n  }\n\n\n  a, .image-focus,\n  #internal-app-backToTop,\n  .btn-link,.ant-btn,.ant-collapse-header,\n  .card__api_list,\n  .ant-tabs-tab-btn,.react-player__preview,\n  .ant-pagination-item-link,\n  .ant-switch ,\n  .filter-checkbox,\n  .expand-button {\n    &:focus-visible {\n      outline: 2px solid #0079c2;\n      outline-offset: 2px;\n      border-radius: 2px;\n    }\n  }\n\n  /* Focus styles for radio button inputs */\n  .ant-radio-input:focus-visible {\n    outline: 2px solid #0079c2 !important;\n    outline-offset: 2px !important;\n    border-radius: 50% !important;\n    opacity: 1;\n  }\n\n  /* Focus styles for checkbox inputs */\n  .ant-checkbox-input:focus-visible {\n    outline: 2px solid #0079c2 !important;\n    outline-offset: 2px !important;\n    border-radius: 2px !important;\n    opacity: 1;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
